import React, { useEffect, useState } from "react";
import { Header } from "../../Components/Header/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./button.css";

declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
  }
}

const BroadcastConnect: React.FC = () => {
  const [scopes, setScopes] = useState<string[]>([]);
  const [granularScopes, setGranularScopes] = useState<string[]>([]);
  const navigate = useNavigate();
  const APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID!;
  const API_VERSION = process.env.REACT_APP_FACEBOOK_API_VERSION!;
  const CONFIG_ID = process.env.REACT_APP_CONFIG_ID!;
  const APP_SECRET = process.env.REACT_APP_APP_SECRET!;

  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: APP_ID,
        cookie: true,
        xfbml: true,
        version: API_VERSION,
      });
    };

    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const handleFBLogin = () => {
    window.FB.login(
      (response: any) => {
        handleLoginResponse(response);
      },
      {
        config_id: CONFIG_ID,
        response_type: "code",
        override_default_response_type: true,
      }
    );
  };

  const handleLoginResponse = async (response: any) => {
    if (response.authResponse?.code) {
      const code = response.authResponse.code;
      try {
        const tokenRes = await axios.post(
          `https://graph.facebook.com/${API_VERSION}/oauth/access_token`,
          new URLSearchParams({
            client_id: APP_ID,
            client_secret: APP_SECRET,
            code: code,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        const accessToken = tokenRes.data.access_token;
        sessionStorage.setItem("access_token", accessToken);
        // Debug token and fetch scopes
        const debugRes = await axios.get(
          `https://graph.facebook.com/${API_VERSION}/debug_token`,
          {
            params: {
              input_token: accessToken,
              access_token: `${APP_ID}|${APP_SECRET}`,
            },
          }
        );
        const { scopes, granular_scopes } = debugRes.data.data;
        setScopes(scopes || []);
        setGranularScopes(granular_scopes?.map((g: any) => g.scope) || []);
        // Navigate to next page
        navigate("/facebookManage", {
          state: { tokenObjbroadcast: accessToken },
        });
        localStorage.setItem("accessToken", accessToken);
      } catch (err) {
        console.error("Error during token exchange or debug:", err);
      }
    } else {
      console.error("Login failed or no code received.");
    }
  };

  return (
    <div className="account-pages container-login100">
      <div className="container">
        <Header />
        <div className="row justify-content-center mb-4">
          <div className="col-sm-12 col-md-8 col-lg-6 col-xl-5">
            <div className="card fb-title">
              <div className="card-body text-center">
                <div className="card-block">
                  <h1 className="card-title mt-3 mb-0">
                    Connect Caucus to your Facebook Page
                  </h1>
                  <div
                    className="fb-button mt-4"
                    style={{ marginLeft: "100px" }}>
                    <button className="fb-login-button" onClick={handleFBLogin}>
                      <div className="icon-circle">
                        <span className="fab fa-facebook-f"></span>
                      </div>
                      Login with Facebook
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BroadcastConnect;
